export function estimateTime(tasks: number, minutes: number, share: number) {
  if (![tasks, minutes, share].every(Number.isFinite) || tasks < 0 || minutes < 0 || share < 0 || share > 100) throw new RangeError('Invalid time estimate');
  const baseline = tasks * minutes;
  const recovered = baseline * share / 100;
  return { baseline, recovered, remaining: baseline - recovered, fourWeeks: recovered * 4 };
}
